import axios from 'axios';
import { ElMessage } from 'element-plus';

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '/api';

const request = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000
});

async function readBlobMessage(blob) {
  if (!(blob instanceof Blob)) {
    return '';
  }

  const contentType = blob.type || '';
  if (!contentType.includes('application/json') && !contentType.includes('text/plain')) {
    return '';
  }

  const text = await blob.text();
  if (!text) {
    return '';
  }

  try {
    const parsed = JSON.parse(text);
    return parsed.message || parsed.errmsg || text;
  } catch (parseError) {
    return text;
  }
}

async function extractErrorMessage(error) {
  const responseData = error?.response?.data;
  const blobMessage = await readBlobMessage(responseData);
  if (blobMessage) {
    return blobMessage;
  }

  if (typeof responseData?.message === 'string' && responseData.message.trim()) {
    return responseData.message;
  }

  if (typeof error?.message === 'string' && error.message.trim()) {
    return error.message;
  }

  return '请求失败';
}

request.interceptors.request.use(
  config => config,
  error => Promise.reject(error)
);

request.interceptors.response.use(
  response => response.data,
  async error => {
    const message = await extractErrorMessage(error);
    error.userMessage = message;
    ElMessage.error(message);
    return Promise.reject(error);
  }
);

export default request;
